@if (breadcrumbs.length > 0) {
  <ds-breadcrumb [breadcrumbs]="breadcrumbs" data-test-id="ds-breadcrumb"></ds-breadcrumb>
}
@if (doneLoading) {
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>{{ pageTitle }}</h1>
        </div>
        <div class="card-body">
          @if (errorResponseMessages.length > 0) {
            <div class="row">
              <div class="col-md-12 margin-bottom">
                <app-alert
                  [type]="alertType.danger"
                  [technicalDetails]="errorResponseMessages"
                  [header]="'error_tenant_header' | translate"
                  [message]="errorMessage | translate"
                >
                </app-alert>
              </div>
            </div>
          }
          <div class="row">
            <div class="col-12">
              <form [formGroup]="form">
                <div class="row">
                  <div class="col-12">
                    {{ 'required_fields_label' | translate }}
                  </div>
                </div>
                <div class="col-12">
                  <app-common-input [form]="form" [formValidationRequest$]="formValidationRequest" [context]="nameInputContext">
                  </app-common-input>
                  <app-form-field-char-count
                    [field]="form.get(FormFields.name)"
                    [charLimit]="charLimits[FormFields.name]"
                  ></app-form-field-char-count>
                </div>
                @if (showSalesforceField === true) {
                  <div class="row my-4">
                    <div class="col-8">
                      <label [for]="'salesforce-account-name'">
                        {{ 'salesforce_account_name' | translate }}
                      </label>
                      <input
                        type="text"
                        id="salesforce-account-name"
                        class="w-100 d-block margin-bottom form-element"
                        [attr.aria-invalid]="form | fieldInvalid: FormFields.salesforceAccount"
                        [ngbTypeahead]="searchSalesforceAccounts"
                        [popupClass]="'typeahead-popup'"
                        [inputFormatter]="tenantNameFormatter"
                        [resultFormatter]="tenantNameFormatter"
                        (selectItem)="selectSalesforceAccount($event)"
                        [formControlName]="FormFields.salesforceAccount"
                      />
                      <div id="salesforce-account-name-error" class="error-container">
                        <app-form-field-error
                          [formValidationRequest$]="formValidationRequest"
                          [field]="form.get(FormFields.salesforceAccount)"
                          [name]="FormFields.salesforceAccount"
                          [label]="'tenant_name'"
                        ></app-form-field-error>
                      </div>
                    </div>
                    <div class="col-4 ps-2">
                      <label>{{ 'salesforce_id' | translate }}</label>
                      <div id="salesforce-account-id" class="fw-normal">
                        <p>{{ selectedSalesforceAccount?.Id || 'will_be_auto_populated' | translate }}</p>
                      </div>
                    </div>
                  </div>
                }
                @if (isAlertOpen(Alerts.name)) {
                  <div id="tenant-name-warning" class="row mb-3">
                    <div class="col-12">
                      <div class="alert alert-warning" role="alert">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <svg class="warning-symbol" aria-hidden="true" focusable="false">
                              <use xlink:href="#exclamation-triangle"></use>
                            </svg>
                            <span class="ms-2 text-black">{{ 'preexisting_organization_warning' | translate }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (isAlertOpen(Alerts.salesforceAccount)) {
                  <div id="salesforce-account-warning" class="row">
                    <div class="col-12">
                      <div class="alert alert-warning" role="alert">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <svg class="warning-symbol" aria-hidden="true" focusable="false">
                              <use xlink:href="#exclamation-triangle"></use>
                            </svg>
                            <span class="ms-2 text-black">{{ 'preexisting_sf_account_warning' | translate }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <!-- Tenant description or internal notes -->
                @if (descriptionFieldConfig$ | async; as config) {
                  <div class="row mt-4">
                    <div class="col-12">
                      <app-common-textarea
                        [form]="form"
                        [formValidationRequest$]="formValidationRequest"
                        [context]="{
                          label: config.label,
                          field: config.field,
                          placeholder: '',
                          required: false,
                        }"
                      >
                      </app-common-textarea>
                      <app-form-field-char-count [field]="form.get(config.field)" [charLimit]="config.charLimit">
                      </app-form-field-char-count>
                    </div>
                  </div>
                }
                <!-- Subdomain field -->
                @if (domainFieldEditable) {
                  <div class="row my-4">
                    <div class="col-12">
                      <label id="domain-label" class="required"
                        >{{ 'enter_personalized_subdomain' | translate }}<span class="color-error"> *</span></label
                      >
                      <div class="input-description">
                        {{ 'subdomain_characters_requirements' | translate }}
                      </div>
                      <div class="input-group">
                        <div class="input-group-text">
                          {{ 'https_slash' | translate }}
                        </div>
                        <input
                          type="text"
                          id="domain"
                          class="form-control"
                          aria-required="true"
                          [formControlName]="FormFields.domain"
                          [attr.aria-labelledby]="'domain-label ' + FormFields.domain + '-error'"
                        />
                        <div class="input-group-text" data-test-id="tenant-base-url">.{{ tenantBaseUrl }}</div>
                      </div>
                      <div [id]="FormFields.domain + '-error'" class="error-container">
                        <app-form-field-error
                          [formValidationRequest$]="formValidationRequest"
                          [field]="form.get(FormFields.domain)"
                          [name]="'subdomain'"
                          [overrideErrors]="{
                            unique: 'form_error_unique_subdomain' | translate,
                          }"
                        >
                        </app-form-field-error>
                      </div>
                      <app-form-field-char-count
                        [field]="form.get(FormFields.domain)"
                        [charLimit]="charLimits[FormFields.domain]"
                      ></app-form-field-char-count>
                    </div>
                  </div>
                  @if (isAlertOpen(Alerts.subdomain)) {
                    <div class="row">
                      <div class="col-12">
                        <div class="alert alert-warning" role="alert">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <svg class="warning-symbol" aria-hidden="true" focusable="false">
                                <use xlink:href="#exclamation-triangle"></use>
                              </svg>
                              <span class="ms-2 text-black">{{ 'subdomain_cannot_be_changed_warning' | translate }}</span>
                            </div>
                            <div class="col-auto flex-grow-1 d-flex justify-content-end">
                              <button class="dismiss-alert-button" (click)="closeAlert(Alerts.subdomain)">
                                <svg viewBox="0 0 8 8" class="cross-solid">
                                  <use xlink:href="#cross-solid"></use>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                }
                @if (!domainFieldEditable) {
                  <div class="row my-4">
                    <div class="col-12">
                      <label>{{ 'personalized_subdomain' | translate }}</label>
                      <div id="subdomain">{{ personalizedSubdomain }}</div>
                    </div>
                  </div>
                }
                @if (isDigitalAssetsPrivacySettingEnabled) {
                  <div class="row my-4">
                    <div class="col-12">
                      <app-confidential-scanning-switch
                        [value]="confidentialScanningEnabled"
                        (valueChange)="updateConfidentialScanning($event)"
                      ></app-confidential-scanning-switch>
                    </div>
                  </div>
                }
                @if (canToggleScanningAgentDebugMode) {
                  <div class="row my-4">
                    <div class="col-12">
                      <app-scanning-agent-debug-mode-switch
                        [value]="scanningAgentDebugModeEnabled"
                        (valueChange)="updateScanningAgentDebugMode($event)"
                      ></app-scanning-agent-debug-mode-switch>
                    </div>
                  </div>
                }
                <!-- AI section -->
                @if (artificialIntelligenceEnabled) {
                  <div class="row mt-4">
                    <div class="col-12">
                      <h2 class="h5" data-test-id="ai-heading">{{ 'artificial_intelligence' | translate }}</h2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <ds-checkbox-group
                        [formControlName]="FormFields.artificialIntelligence"
                        [hideSelectAll]="true"
                        data-test-id="ai-checkbox-group"
                      >
                        @for (opt of aiOptions; track opt.id) {
                          <ds-checkbox [checkboxId]="opt.id" [value]="opt.value" [label]="opt.label"></ds-checkbox>
                        }
                      </ds-checkbox-group>
                    </div>
                  </div>
                }
                <!-- Package selector -->
                <div class="row my-4">
                  <div class="col-12">
                    <app-package-selector
                      [form]="form"
                      [fieldName]="FormFields.package"
                      [packages]="displayPackages$ | async"
                      [isDisabled]="isPackageSelectionDisabled"
                      [formValidationRequest$]="formValidationRequest"
                      (packageSelected)="selectPackage($event)"
                      (packageCleared)="clearPackageUsageLimits()"
                    ></app-package-selector>
                  </div>
                </div>
                <!-- Package addons -->
                @if (packageAddons$ | async; as packageAddons) {
                  @if (packageAddons.length > 0) {
                    <div class="row mt-4">
                      <div class="col-12">
                        <h2 class="h5" data-test-id="package-addons-heading">{{ 'addons' | translate }}</h2>
                      </div>
                    </div>
                    <div class="row addon-checkboxes">
                      <div class="col-12">
                        <ds-checkbox-group
                          [value]="displayedSelectedAddonIds"
                          [hideSelectAll]="true"
                          (valueChange)="selectPackageAddon($event)"
                          data-test-id="package-addon-checkbox-group"
                        >
                          @for (addon of packageAddons; track addon[$packageAddon._id]) {
                            <ds-checkbox
                              [checkboxId]="addon[$packageAddon._id]"
                              [value]="addon[$packageAddon._id]"
                              [label]="addon[$packageAddon.name] + ' - ' + addon[$packageAddon.description]"
                            ></ds-checkbox>
                          }
                        </ds-checkbox-group>
                      </div>
                    </div>
                  }
                }
                <!-- Digital Asset Complexity Calculator -->
                <div class="row my-4">
                  <div class="col-12">
                    <h2 class="h5">{{ 'label_usage_limits' | translate }}</h2>
                  </div>
                  @if (showDpComplexityCalculator) {
                    <div class="col-12 mt-3 mb-4">
                      <app-digital-asset-complexity-calculator
                        [digitalPropertyLimitControl]="form.get(FormFields.digitalPropertyLimit)"
                        [formControlName]="FormFields.dpComplexityCounts"
                        [formValidationRequest$]="formValidationRequest"
                        [allocatedDigitalProperties]="allocatedResources.digitalProperties"
                      >
                      </app-digital-asset-complexity-calculator>
                    </div>
                  }
                </div>

                <!-- Other Usage Limits -->
                <div class="d-flex flex-wrap gap-2">
                  @if (!showDpComplexityCalculator) {
                    <div class="col-usage-limit">
                      <app-usage-limit
                        [form]="form"
                        [formValidationRequest$]="formValidationRequest"
                        [attr.data-test-id]="FormFields.digitalPropertyLimit + '_total'"
                        [context]="{
                          label: 'digital_properties',
                          field: FormFields.digitalPropertyLimit,
                          overrideErrors:
                            allocatedResources.digitalProperties > 0
                              ? { min: 'package_limits_lower_than_usage' | translate }
                              : undefined,
                        }"
                        [defaultValue]="getIncludedAmount('digitalPropertyLimit')"
                      >
                      </app-usage-limit>
                    </div>
                  }
                  <div class="col-usage-limit">
                    <app-usage-limit
                      *featureFlag="FeatureFlagCollection.newPackageMonitoringLimits"
                      [form]="form"
                      [formValidationRequest$]="formValidationRequest"
                      [context]="{
                        label: 'label_monitored_pages',
                        field: FormFields.monitoringPagesPerDigitalPropertyLimit,
                        tooltip: 'monitoring_page_limit_tooltip',
                        maxLimit: maxMonitoringPagesPerDigitalPropertyLimit,
                      }"
                      [defaultValue]="getIncludedAmount('monitoringPagesLimitWithFF')"
                    >
                    </app-usage-limit>
                    <app-usage-limit
                      *featureFlag="revertFlag(FeatureFlagCollection.newPackageMonitoringLimits)"
                      [form]="form"
                      [formValidationRequest$]="formValidationRequest"
                      [context]="{
                        label: 'label_monitored_pages',
                        field: FormFields.monitoringPagesPerDigitalPropertyLimit,
                        tooltip: 'monitoring_page_limit_tooltip',
                        maxLimit: maxMonitoringPagesPerDigitalPropertyLimit,
                      }"
                      [defaultValue]="getIncludedAmount('monitoringPagesLimit')"
                    >
                    </app-usage-limit>
                  </div>
                  <div class="col-usage-limit">
                    <app-usage-limit
                      [form]="form"
                      [formValidationRequest$]="formValidationRequest"
                      [context]="getPdfPagesTestInputContext()"
                      [defaultValue]="getIncludedAmount('pdfPagesLimit')"
                    >
                    </app-usage-limit>
                  </div>

                  <div class="col-usage-limit">
                    <app-usage-limit
                      [form]="form"
                      [formValidationRequest$]="formValidationRequest"
                      [context]="{
                        label: 'label_academy_seats',
                        field: FormFields.seatLimit,
                        overrideErrors:
                          allocatedResources.academySeats > 0
                            ? { min: 'package_limits_lower_than_usage' | translate }
                            : undefined,
                        maxLimit: maxSeatLimit,
                      }"
                      [defaultValue]="getIncludedAmount('academySeatsLimit')"
                    >
                    </app-usage-limit>
                  </div>
                  @if (showUserWayWebsiteLimit) {
                    <div class="col-usage-limit">
                      <app-usage-limit
                        [form]="form"
                        [formValidationRequest$]="formValidationRequest"
                        [context]="{
                          label: 'label_widget_websites',
                          field: FormFields.userWayWebsiteLimit,
                          tooltip: 'widget_website_limit_tooltip',
                        }"
                        [defaultValue]="getIncludedAmount('userWayWebsiteLimit')"
                      >
                      </app-usage-limit>
                    </div>
                  }
                  <div class="col-usage-limit" *featureFlag="FeatureFlagCollection.defaultScanTimeout">
                    <app-scan-default-timeout
                      [form]="form"
                      [fieldName]="FormFields.scanDefaultTimeoutHours"
                      [formValidationRequest$]="formValidationRequest"
                      [minScanTimeoutHours]="minScanTimeoutHours"
                      [maxScanTimeoutHours]="maxScanTimeoutHours"
                      [scanningAgentCurrentVersion]="(tenant$ | async)?.scanningAgentCurrentVersion"
                    ></app-scan-default-timeout>
                  </div>
                </div>
                <!-- Scan Options -->
                <div class="row gy-3" *featureFlag="FeatureFlagCollection.scanDebugging">
                  <div class="col-12">
                    <h2 class="h5">{{ 'label_scan_options' | translate }}</h2>
                  </div>
                  <div class="col-12">
                    <app-scan-extra-headers
                      data-test-id="tenant-scan-options-headers"
                      class="d-flex ps-3"
                      [form]="form.get(FormFields.scanOptions)"
                      [formValidationRequest$]="formValidationRequest"
                      [headers]="(tenant$ | async)?.scanOptions?.headers"
                      [modifyHeaders]="(tenant$ | async)?.scanOptions?.modifyHeaders || false"
                    ></app-scan-extra-headers>
                  </div>
                  <div class="col-12">
                    <app-scan-custom-browser-flags
                      data-test-id="tenant-scan-options-browser-flags"
                      class="d-flex ps-3"
                      [form]="form.get(FormFields.scanOptions)"
                      [formValidationRequest$]="formValidationRequest"
                      [browserFlags]="(tenant$ | async)?.scanOptions?.browserFlags"
                      [modifyBrowserFlags]="(tenant$ | async)?.scanOptions?.modifyBrowserFlags"
                    ></app-scan-custom-browser-flags>
                  </div>
                  <div class="col-12">
                    <app-scan-custom-browser-timeouts
                      data-test-id="tenant-scan-options-browser-timeouts"
                      class="d-flex ps-3"
                      [form]="form.get(FormFields.scanOptions)"
                      [formValidationRequest$]="formValidationRequest"
                      [browserTimeouts]="(tenant$ | async)?.scanOptions?.browserTimeouts"
                      [modifyBrowserTimeouts]="(tenant$ | async)?.scanOptions?.modifyBrowserTimeouts"
                    ></app-scan-custom-browser-timeouts>
                  </div>
                  <div class="col-12">
                    <app-scan-force-get
                      class="d-flex ps-3"
                      [form]="form.get(FormFields.scanOptions)"
                      [forceGet]="(tenant$ | async)?.scanOptions?.forceGet"
                    >
                    </app-scan-force-get>
                  </div>
                </div>
                <!-- pdf tested -->
                @if (allocatedResources.pdfPagesTested > 0) {
                  <div class="row my-4">
                    <div class="col-12">
                      <span class="label">{{ 'pdfs_tested' | translate }}</span>
                      <div id="pdf-pages-tested">
                        {{ 'pdfs_tested_since' | translate: [allocatedResources.pdfPagesTested, tenantCreatedAt] }}
                      </div>
                    </div>
                  </div>
                }
                <!-- Academy signup field (Skilljar) -->
                <div class="row my-4">
                  @if (availableSignupFields$ | async; as availableSignupFields) {
                    <div class="col-12">
                      <app-common-select
                        class="col-12 col-lg-6 col-xl-3 offset-xl-3"
                        [values]="availableSignupFields.options"
                        [form]="form"
                        [formValidationRequest$]="formValidationRequest"
                        [context]="{
                          field: FormFields.externalPackageSignupField,
                          required: !makeAcademyOptional,
                          label: 'label_academy_package',
                          nameKey: 'value',
                          placeholderValue: 'label_select_an_academy_package' | translate,
                        }"
                        data-test-id="academy-signup-field-select"
                      ></app-common-select>
                    </div>
                  }
                </div>
                @if (tenantId) {
                  <app-amp-api-key [tenantId]="tenantId"></app-amp-api-key>
                }
                <div class="row mt-4">
                  <div class="action-buttons">
                    <button
                      class="action-button"
                      ds-button
                      id="save_tenant_btn"
                      [variant]="DsButtonVariants.primary"
                      type="submit"
                      (click)="submit()"
                    >
                      {{ 'action_save' | translate }}
                    </button>
                    <button
                      class="action-button"
                      ds-button
                      id="close_tenant_btn"
                      [variant]="DsButtonVariants.secondary"
                      (click)="onClose()"
                    >
                      {{ 'label_close' | translate }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
